// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.staging.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiUrl: 'https://backend-fitpass.dev.42-projects.com/api',
  appUrl: 'https://frontend-fitpass.dev.42-projects.com',
  production: false,
  auth0Domain: 'dev-yz7iopjv6wxl25kh.eu.auth0.com',
  auth0ClientId: 'yK4le9Cz2U6tLxwE363hpsoIZDtDkEy9',
  auth0Audience: 'https://backend-fitpass.dev.42-projects.com/api',
  roleNamespace: 'https://app.easy-fitpass.com/roles',
  smartlookEnabled: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
